import { UPGRADE_BENEFITS_MODAL, UPGRADE_PLAN_MODAL, UPGRADE_PROTECTION_MODAL } from './modal';

export const PLAN_TYPE_FR = 'flexible_remuneration';
export const PLAN_TYPE_HEALTH = 'health';

export const UPGRADE_PLAN = 'upgrade_plan';
export const UPGRADE_PROTECTION = 'upgrade_protection';
export const UPGRADE_BENEFITS = 'upgrade_benefits';

export const PLAN_MODALS = {
  upgrade_plan: UPGRADE_PLAN_MODAL,
  upgrade_protection: UPGRADE_PROTECTION_MODAL,
  upgrade_benefits: UPGRADE_BENEFITS_MODAL
};

export const NO_PLANS_URL = 'https://betterfly.com/es-cl/habla-con-un-experto/';
